import { FormValidator } from '~/modules';

export const validationSchema = FormValidator.object().shape({
  amount: FormValidator.string().required('Campo obrigatório'),
  destinationId: FormValidator.string(),
});

export const initialValues: UpdateLimit = {
  amount: '',
  metadata: [{ key: '', value: '' }],
};
